import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class ReservationSteps extends React.Component {
  constructor(props) {
    super(props)
    this.pages = {
      availability: 1,
      contact: 2,
      boat: 3,
      summary: 4,
    }
    this.classForPage = this.classForPage.bind(this)
    this.classForHover = this.classForHover.bind(this)
    this.clickForPage = this.clickForPage.bind(this)
    this.canClickToPage = this.canClickToPage.bind(this)
  }

  classForPage(pageIndex) {
    const currentIndex = this.pages[this.props.page]
    if (pageIndex === currentIndex) {
      return "border-blue-500 text-blue-700"
    } else if (pageIndex < currentIndex) {
      return "border-blue-300 text-blue-700 bg-blue-100"
    } else {
      return "border-gray-300"
    }
  }

  classForHover(page) {
    if (this.canClickToPage(page)) {
      return "cursor-pointer hover:border-teal-500 hover:text-teal-700 hover:bg-transparent"
    }
  }

  clickForPage(page) {
    if (this.canClickToPage(page)) {
      this.props.setPage(page)
    }
  }

  canClickToPage(page) {
    if (["availability", "contact"].includes(page)) {
      return true
    } else if (page === "boat" && this.props.contactId) {
      return true
    } else if (
      page === "summary" &&
      this.props.contactId &&
      this.props.boatId
    ) {
      return true
    } else {
      return false
    }
  }

  render() {
    return (
      <div className="mb-8 mt-4 flex items-center justify-center space-x-16">
        {_.map(this.pages, (index, page) => (
          <div
            key={index}
            onClick={() => this.clickForPage(page)}
            className={`${this.classForPage(index)} ${this.classForHover(
              page
            )} h4 m-0 flex h-10 w-10 items-center justify-center rounded-full border-2 font-semibold`}
          >
            {index}
          </div>
        ))}
      </div>
    )
  }
}

ReservationSteps.propTypes = {
  page: PropTypes.string.isRequired,
  contactId: PropTypes.string,
  boatId: PropTypes.string,
  setPage: PropTypes.func.isRequired,
}

export default ReservationSteps
